module.exports = __webpack_public_path__ + "static/img/img_4.e628a75c.png";